import React, { forwardRef, useState } from 'react';
import { readOnlyAction, useAdminAccess } from 'contexts/adminAccess';
import { FieldProps, InjectedFieldProps } from 'react-admin';

import MenuItem from '@material-ui/core/MenuItem';

import EditLevelDialog from './EditLevelDialog';
import { RewardLevelDto } from '../../types';

type EditLevelActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardLevelDto;
};

const EditLevelActionField = forwardRef<HTMLLIElement, EditLevelActionFieldProps>(
  ({ record }, ref) => {
    const { canWrite } = useAdminAccess();
    const [open, setOpen] = useState<boolean>(false);
    const isEditable = record?.validUntil === null;

    const handleOpen = () => {
      if (canWrite && !isEditable) {
        return;
      }

      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <>
        <MenuItem ref={ref} onClick={handleOpen} disabled={canWrite && !isEditable}>
          {canWrite ? 'Edit' : 'View'}
        </MenuItem>

        {open && (!canWrite || isEditable) && (
          <EditLevelDialog open={open} onClose={handleClose} level={record} />
        )}
      </>
    );
  }
);

export default readOnlyAction(EditLevelActionField);
